import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import homehero from "../assets/Images/whitehawk/background2.png";
import hashtag from "../assets/Images/whitehawk/hashtag.png";
import screen from "../assets/Images/whitehawk/iPad Mockup.png";
import Title from "../Co Components/Titles";
import PrimaryButton from "../Co Components/PrimaryButton";
import SecondaryButton from "../Co Components/SecondaryButton";
import HomeCard from "../Co Components/HomeCards";
import HomeCards from "../Co Components/HomeCards";
import LineButton from "../Co Components/LineButton";
import logofoot from '../assets/Images/logo-foot.png';
import Customers from './Customers';
import Certs from './certs';
import Secure from './Secure';
import { Link } from "react-router-dom";
import { useEffect } from 'react';
import Impact from "../Page Components/impactContainer";
import whiteHawkCard from "../Co Components/whitehawk-cards";
import WhiteHawkCard from "../Co Components/whitehawk-cards";
import {Col} from "react-bootstrap";

const WhiteHawk = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row justify-content-lg-between align-items-center '}>
                <article className=' ms-1 articleHeader w-lg-50 w-xl-100'>
                    <img src={hashtag} style={{width:'125px',height:'125px'}} className={'position-absolute mx-lg-5'} />
                    <div className={'position-relative mx-5'} >
                        {/*<figure style={{width:'300px',height:'200px'}}>*/}
                        {/*</figure>*/}
                        <h1 className={'text-black headerHome display-1 bolder'} style={{marginTop:'50px',marginLeft:'50px'}}>
                            <span className={'bolder'}>
                                WHITE HAWK
                            </span>
                        </h1>
                        <h3 className={'text-black bolder mx-5'}>Detect, Defend, Defeat Cyber Threats</h3>
                        <h4 className={' bolder mx-5'}><i>Comprehensive Cybersecurity Management</i></h4>
                       <Link className={'mx-5'} to='/contact'><PrimaryButton className={' mt-sm-4 w-120'} text="SEE IN ACTION" /></Link>

                    </div>


                </article>
                <figure className='w-50  d-none d-lg-block'>
                    <img src={homehero} className={'serviceImage'} />
                </figure>

            </section>
            <Title header={"our"} body={"Impact"} />
            <Impact />



            <Title header={"our"} body={"Key Features"} />
            <div className={'d-flex flex-row flex-wrap justify-content-center mt-5'}>
                <Col xl={3} lg={4} md={6} sm={6} >
                    <WhiteHawkCard Title={'Cybersecurity Management Simplification'} text={'Implement a centralized\n' +
                    'dashboard that integrates\n' +
                    'various cybersecurity tools\n' +
                    'and processes, simplifying\n' +
                    'management and\n' +
                    'oversight.'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className={'mx-5'}>
                    <WhiteHawkCard Title={'Tools, Software, and\n' +
                        'Expertise Combination'} text={'Utilize a combination of\n' +
                        'cutting-edge\n' +
                        'cybersecurity tools,\n' +
                        'software solutions, and\n' +
                        'expert knowledge in a\n' +
                        'SaaS model.'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6}>
                    <WhiteHawkCard Title={'Security Reviews for IT\n' +
                        'Infrastructure and\n' +
                        'Applications\n'} text={'Perform regular security\n' +
                        'reviews of the IT\n' +
                        'infrastructure and\n' +
                        'applications to identify\n' +
                        'and address any security\n' +
                        'gaps or weaknesses\n' +
                        'proactively.\n'}/>
                </Col>
            </div>
            <div className={'d-flex flex-row flex-wrap justify-content-center mt-5 mb-5'}>
                <Col xl={3} lg={4} md={6} sm={12}>
                    <WhiteHawkCard Title={'Automated and Manual\n' +
                        'Penetration Testing'} text={'Conduct both automated\n' +
                        'and manual penetration\n' +
                        'testing regularly to identify\n' +
                        'vulnerabilities and assess\n' +
                        'the resilience of the\n' +
                        'infrastructure against\n' +
                        'potential cyber threats.'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={12} className={'mx-5'}>
                    <WhiteHawkCard Title={'Assets Discovery and\n' +
                        'Management'} text={'Deploy tools and\n' +
                        'techniques for identifying\n' +
                        'and managing all assets\n' +
                        'to ensure comprehensive\n' +
                        'security coverage.'}/>
                </Col>
                <Col xl={3} lg={4} md={6} sm={12}>
                    <WhiteHawkCard Title={'Data Breach Monitoring\n' +
                        'and Threat Intelligence'} text={'Implement robust\n' +
                        'monitoring systems to\n' +
                        'detect and respond to\n' +
                        'potential data breaches\n' +
                        'promptly, leveraging\n' +
                        'threat intelligence to stay\n' +
                        'ahead of emerging\n' +
                        'threats.'}/>
                </Col>
            </div>

            <Title header={"our"} body={"Dashboard"} />
            <section className={'d-flex flex-row  flex-wrap justify-content-evenly  '}>
                <div>
                    <img src={screen} style={{width:'100%',height:'100%'}} />
                </div>
            </section>

            <Footer />
        </>
    );

}

export default WhiteHawk;

